<template>
  <div>
    <div class="tg-logo tg-espacio">
      <img :src="logoAsociacion">

    </div>
    <div class="tg-asoc tg-espacio">
      <strong>
        Asociación
        Regional
        de
        Diálisis
        y<br />
        Transplantes Renales</strong>
    </div>
    <div class="tg-tipo tg-espacio">
      <slot></slot>

    </div>
  </div>
</template>

<script>
import appConfig from '@/config/appConfig'
export default {
  data () {
    return {
      logoAsociacion: appConfig.logoAsociacion
    }
  }
}
</script>

<style lang="scss" scoped>
.tg .tg-logo {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: left;
  font-size: 12px;
  vertical-align: top;
  border-top: none !important;
  border-bottom: none !important;
  width: 20%;
  display: inline-block;
}
.tg .tg-asoc {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: left;
  font-size: 12px;
  vertical-align: top;
  border-top: none !important;
  border-bottom: none !important;
  width: 30%;
  display: inline-block;
}
.tg .tg-tipo {
  font-family: Verdana, Geneva, sans-serif !important;
  text-align: right;
  vertical-align: top;
  font-weight: 500;
  border-top: none !important;
  border-bottom: none !important;
  font-size: 19px;
  width: 50%;
  display: inline-block;
}
</style>
